import { Component, Inject, OnInit } from '@angular/core';
import { Card } from '../../../models/card';
import { Observable, of } from 'rxjs';
import { UntypedFormControl, UntypedFormGroup, ReactiveFormsModule, FormGroup, FormControl } from '@angular/forms';
import { emptyCard } from '../../../constants/empty-card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { CardFormComponent } from '../../shared/card-form/card-form.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-card-edit',
    templateUrl: './card-edit.component.html',
    styleUrls: ['./card-edit.component.scss'],
    imports: [CardFormComponent, ReactiveFormsModule, MatButton, AsyncPipe]
})
export class CardEditComponent implements OnInit {

    public card: Card;
    public card$: Observable<Card>;

    constructor(@Inject(MAT_DIALOG_DATA) data: { card: Card }, private dialogRef: MatDialogRef<CardEditComponent>) {
        this.card = data.card;
        if (this.card) {
            this.card$ = of(this.card);
        } else {
            this.card$ = of(emptyCard);
        }
    }

    ngOnInit(): void {
    }

    save(): void {
        this.dialogRef.close(this.card);
    }

    cancel(): void {
        this.dialogRef.close(null);
    }

    update($event: Partial<Card>): void {
        this.card = { ...this.card, ...$event };
    }
}
